import api from '../../config/axios.js';
import moment from 'moment';
import { isAuthenticated } from '@/services/authService';
import { getDefaultModulePath } from '@/helpers/permissions.js';
import { isPublicPath } from '@/helpers/publicRoutes.js';

const state = {
    id: '',
    name: "",
    cell_phone: "",
    commercial_phone: "",
    active: "",
    email: "",
    company_id: "",
    created_at: "",
    configurations: {},
    errorRegister: "",
    errorForgotPasswordSendEmail: "",
    configurationSftp: [],
    currentConfigurationSftp: {},
    usersList: [],
    currentDeleteUser: {},
    currentUpdateUser: {},
    operations: [],
    operation: null,
    loadedOperations: false,
    permissions: [],
    rolesList: []
}
const getters = {
    getId: state => state.id,
    getName: state => state.name,
    getPhone: state => state.phone,
    getBirthday: state => (state.birthday != null) ? moment(state.birthday).format('DD/MM/YYYY') : 'Não Informado',
    getActive: state => state.active,
    getEmail: state => state.email,
    getCompany_id: state => state.company_id,
    getCreatedAt: state => (state.created_at != null) ? moment(state.created_at).format('DD/MM/YYYY') : 'Não Informado',
    getConfigurations: state => state.configurations,
    getErrorRegister: state => state.errorRegister,
    getErrorForgotPasswordSendEmail: state => state.errorForgotPasswordSendEmail,
    getConfigurationSftp: state => state.configurationSftp,
    getCurrentConfigurationSftp: state => state.currentConfigurationSftp,
    getUsersList: state => state.usersList,
    getCurrentDeleteUser: state => state.currentDeleteUser,
    getCurrentUpdateUser: state => state.currentUpdateUser,
    getOperations: state => state.operations,
    getOperation: state => state.operation,
    getLoadedOperations: state => state.loadedOperations,
    getPermissions: state => state.permissions,
    getRolesList: state => state.rolesList,
}
const actions = {
    // BUSCANDO AS ROLES
    async setRolesList({ commit }){
        commit("resetLoadedOperation", false);
        await api.axios.get('/api/roles').catch(() => {
            commit("setRolesList", []);
        }).then(response => {
            if(response && response.data){
                commit("setRolesList", response.data);
            } else {
                commit("setRolesList", []);
            }
        });
    },
    // BUSCANDO AS OPERAÇÕES DO CLIENTE
    async setOperations({ commit }){
        commit("resetLoadedOperation", false);
        await api.axios.get('/api/operations').catch((error) => {
            if(error.response && error.response.data){
                commit("setOperations", []);
            }
        }).then(response => {
            if(response && response.data){
                commit("setOperations", response.data);
            } else {
                commit("setOperations", []);
            }
        });
    },
    // BUSCANDO UMA OPERAÇÃO ESPECÍFICA
    async setOperation({ commit }, id){
        await api.axios.get('/api/operation/'+id).catch((error) => {
            if(error.response && error.response.data){
                commit("setOperation", null);
            }
        }).then(response => {
            if(response && response.data){
                commit("setOperation", response.data);
            } else {
                commit("setOperation", null);
            }
        });
    },

    // REALIZANDO CRIAÇÃO DA EMPRESA/USUÁRIO
    async sendRegister({ commit }, obj){
        await api.axios.post('/api/register', obj).catch((error) => {
            if(error.response && error.response.data){
                commit("setErrorRegister", error.response.data);
            }
        }).then(response => {
            if(response && response.data && response.data.token != undefined){
                commit("setTokenSession");
            } else if(response && response.data) {
                location.reload();
            }
        });
    },
    // ENVIAR EMAIL DE ESQUECI MINHA SENHA
    async sendForgotPasswordSendEmail({ commit }, obj){
        await api.axios.post('/api/reset/password/email', {email: obj.email}).catch((error) => {
            if(error.response && error.response.data){
                commit("setErrorForgotPasswordSendEmail", error.response.data);
            }
        }).then(response => {
            if(response && response.status && response.status == 200){
                obj.router.push('/send-email-forgot-password');
            }
        });
    },
    // SETANDO ERRO EM VALIDAÇÕES FORGOT PASSWORD
    async setErrorForgotPasswordSendEmail({ commit }, message){
        commit("setErrorForgotPasswordSendEmail", message);
    },
    // REALIZANDO LOGIN
    async sendCreateSession(obj){
        await window.axios.post('/api/login', obj).catch(() => {
            console.log("tratar erro de login");
        }).then(async response => {
            if(response && response.data && response.data.token != undefined){
                await api.axios.get('/api/me').then((profileResponse) => {
                    window.location.href = getDefaultModulePath(profileResponse.data.permissions || []);
                });
            }         
        });
    },
    // REALIZAR LOGOFF
    async logoffSession() {
        await window.axios.post('/api/logout').catch(function(){
            console.log("erro ao realizar logoff");
        }).then(function(){
            window.location.href = "/login";
        });
    },
    // RECUPERANDO CONFIGURAÇÕES SFTP
    async setConfigurationSftp({commit}) {
        await api.axios.get('/api/configurations/sftp').catch(function(){
            console.log("erro ao recuperar configurações sftp");
        }).then(function(response){
            if(response && response.status && response.status == 200){
                commit('setConfigurationSftp', response.data);
            }
        });
    },
    // SALVANDO A NOVA CONFIGURAÇÃO DE UPLOAD VIA SFTP
    async saveConfigurationSftp({commit}, obj) {
        await api.axios.post('/api/save/configurations/sftp', obj).catch(function(error){
            console.log("erro", error);
        }).then(function(response){
            commit("savedConfigurationSftp", response.data);
            console.log("response", response);
        });
    },
    // BUSCAR CONFIGURAÇÕES
    async setConfiguration({ commit }) {
        if(await isAuthenticated()){
            await api.axios.get('/api/me').catch(function(){
                if(!isPublicPath(window.location.pathname)){
                    window.location.href = "/login";
                }
            }).then(function(response){
                if(response.status == 200){
                    commit('setPermissions', response.data);
                }
            });

            await api.axios.get('/api/configurations').catch(function(){
                if(!isPublicPath(window.location.pathname)){
                    window.location.href = "/login";
                }
            }).then(function(response){
                if(response.status == 200){
                    commit('setConfiguration', response.data);
                }
            });
        } else {
            if(!isPublicPath(window.location.pathname)){
                window.location.href = "/login";
            }
        }
    },
    reloadData({ commit }, data) {
        commit('sendCreateSession', data);
    },
    setNewToken({ commit }, data){
        commit("setNewToken", data);
    },
    setCurrentConfigurationSftp({ commit }, data){
        commit("setCurrentConfigurationSftp", data);
    },
    // LISTANDO USUÁRIOS
    async setUsersList({ commit }){
        await api.axios.get('/api/users').catch(() => {
            commit("setUsersList", []);
        }).then((response) => {
            if(response && response.data){
                commit("setUsersList", response.data);
            }
        });
    },
    async setCurrentDeleteUser({ commit }, data){
        commit('setCurrentDeleteUser', data);
    },
    async setCurrentUpdateUser({ commit }, data){
        commit('setCurrentUpdateUser', data);
    }
}
const mutations = {
    // SETANDO INFORMACOES DE LOGIN
    sendCreateSession: function(state, data){
        state.id = data.id;
        state.name = data.name;
        state.cell_phone = data.cell_phone;
        state.commercial_phone = data.commercial_phone;
        state.active = data.active;
        state.email = data.email;
        state.company_id = data.company_id;
        state.created_at = data.created_at;
    },
    //REALIZADO O SALVAMENTO DA CONFIGURAÇÃO SFTP
    savedConfigurationSftp: function(){
        // state.configurations = data;
    },
    //BUSCANDO CONFIGURAÇÕES ATUAIS
    setConfiguration: function(state, data){
        state.configurations = data;
    },
    setNewToken: function(state, data){
        state.configurations.companyToken = data;
    },
    setTokenSession: function(){
        window.location.href = "/";
    },
    setErrorRegister: function(state, data){
        state.errorRegister = data;
    },
    setErrorForgotPasswordSendEmail: function(state, data){
        state.errorForgotPasswordSendEmail = data;
    },
    setConfigurationSftp: function(state, data){
        state.configurationSftp = data;
    },
    setCurrentConfigurationSftp: function(state, data){
        state.currentConfigurationSftp = data;
    },
    setUsersList: function(state, data){
        state.usersList = data;
    },
    setCurrentDeleteUser: function(state, data){
        state.currentDeleteUser = data;
    },
    setCurrentUpdateUser: function(state, data){
        state.currentUpdateUser = data;
    },
    resetLoadedOperation: function(state, data){
        state.loadedOperations = data;
    },
    setOperations: function(state, data){

        if(data.length > 0){
            state.loadedOperations = true;
            
            if(!localStorage.getItem("selected_operation_id")){
                localStorage.setItem("selected_operation_id", data[0].id);
            } else if(!data.find(op => op.id == localStorage.getItem("selected_operation_id"))){
                localStorage.setItem("selected_operation_id", data[0].id);
            }
        }

        state.operations = data;

    },
    setOperation: function(state, data){
        state.operation = data;
    },
    setPermissions: function(state, data){
        if(data.permissions){
            state.permissions = data.permissions;
        }
    },
    setRolesList: function(state, data){
        state.rolesList = data;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
